export { default as MainPageHeader } from './MainPageHeader.vue';
export { default as TabBarButton } from './TabBarButton.vue';
